const listeners = new Set<Function>();
let currentPreset = 'original';
let currentRoughness = 0.15;
let currentBlur = 0.65;

export const environmentState = {
    get preset() {
        return currentPreset;
    },
    get roughness() {
        return currentRoughness;
    },
    get blur() {
        return currentBlur;
    },
    setEnvironment(preset: string, roughness?: number, blur?: number) {
        let changed = false;
        if (currentPreset !== preset) {
            currentPreset = preset;
            changed = true;
        }
        if (roughness !== undefined && currentRoughness !== roughness) {
            currentRoughness = roughness;
            changed = true;
        }
        if (blur !== undefined && currentBlur !== blur) {
            currentBlur = blur;
            changed = true;
        }

        if (changed) {
            const state = { preset: currentPreset, roughness: currentRoughness, blur: currentBlur };
            listeners.forEach((fn) => fn(state));
        }
    },
    setEnvironmentPreset(preset: string) {
        this.setEnvironment(preset);
    },
    subscribe(callback: (state: { preset: string, roughness: number, blur: number }) => void) {
        listeners.add(callback);
        return () => listeners.delete(callback);
    }
};
